import { ChevronDown } from "lucide-react";
import { FC, HTMLAttributes, ReactNode } from "react";

type NavigationItemContentProps = HTMLAttributes<HTMLDivElement> & {
  icon: ReactNode;
  label: string;
  showArrow?: boolean;
};

const NavigationItemContent: FC<NavigationItemContentProps> = (props) => {
  const showArrow = props.showArrow || false;

  return (
    <div className={props.className}>
      <div className="items flex h-5 w-5 shrink-0 justify-center">
        {props.icon}
      </div>
      <div className="grow text-left">{props.label}</div>
      {showArrow && <ChevronDown />}
    </div>
  );
};

export default NavigationItemContent;
